

























































































































































import { Component, Vue } from 'vue-property-decorator'
import { CarrinhoPublico } from '@/models/venda/Carrinho'
import { FindCarrinhoUseCase } from '@/usecases/venda/FindCarrinhoUseCase'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import CampoDeCnpjOuCpf from '@/components/ui/CampoDeCnpjOuCpf.vue'
import { formatarCnpjOuCpf } from '@/shareds/formatadores'
import { imprimirNotaFiscalPublic } from '@/shareds/venda-shareds'
import { Venda } from '@/models'
import { imprimirCupomSemValorFiscalPublico } from '@/shareds/pedidos/impressao-cupom-sem-valor-fiscal-publico'


@Component({
	components: {
		CampoDeCnpjOuCpf,
	},
})
export default class TelaDoCarrinhoDoCliente extends Vue {
	carrinho: CarrinhoPublico | null = null
	carregando = false
	salvando = false
	erro: string | null = null
	autenticado = false
	cnpjCpfDoCliente = ''
	validando = false
	imprimindoDanfe = false
	venda: Venda | null = null

	formatarDocumento = formatarCnpjOuCpf
	imprimirNotaFiscalPublic = imprimirNotaFiscalPublic

	findCarrinhoUseCase = new FindCarrinhoUseCase()

	get valorTotal() {
		if (!this.carrinho) return 0
		return this.carrinho.valorTotal || 0
	}

	get valorTotalFormatado() {
		return this.formatarValor(this.valorTotal)
	}

	async mounted() {
		const identificador = this.$route.params.identificador
		await this.carregarCarrinho(identificador)
	}

	async carregarCarrinho(identificador: string) {
		this.carregando = true
		this.erro = null
		try {
			this.carrinho = await this.findCarrinhoUseCase.findByIdentificador(
				identificador,
			)

			if (this.carrinho.status === 'Concluido' && this.carrinho.vendedor) {
				this.venda = await this.findCarrinhoUseCase.findVendaPublicDoCarrinho(this.carrinho.id, this.carrinho.vendedor.id)
			}

		} catch (e: any) {
			this.erro =
				e?.message || 'Não foi possível carregar o carrinho. Tente novamente.'
			this.carrinho = null
		} finally {
			this.carregando = false
		}
	}

	formatarValor(valor: number) {
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(valor || 0)
	}

	async concluir() {
		if (!this.carrinho) return

		try {
			this.salvando = true
			this.carrinho = await this.findCarrinhoUseCase.finalizarMalinhaDoCliente(this.carrinho)

		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.salvando = false
		}
	}

	private formatarCnpjOuCpf(doc?: string | null) {
		return (doc || '').replace(/\D/g, '')
	}

	async validarDocumentoDoCliente() {
		if (!this.carrinho || !this.carrinho.cliente) {
			AlertModule.setError('Carrinho inválido.')
			return
		}

		const informado = this.formatarCnpjOuCpf(this.cnpjCpfDoCliente)
		const esperado = this.formatarCnpjOuCpf(this.carrinho.cliente.cnpjOuCpf)

		if (!informado) {
			AlertModule.setError('Informe o CPF ou CNPJ para continuar.')
			return
		}

		if (informado !== esperado) {
			return AlertModule.setError('O documento informado não confere com o cadastro deste carrinho.')
		}

		this.autenticado = true
	}

	get isPendente() {
		return this.carrinho && this.carrinho.status === 'Pendente'
	}

	get isConfirmado() {
		return this.carrinho && this.carrinho.status === 'Confirmado'
	}

	get isFaturado() {
		return this.carrinho && this.carrinho.status === 'Concluido' && !this.venda?.possuiNotaNaoEletronica
	}

	get isDocumentoSemValorFiscal() {
		return this.carrinho && this.carrinho.status === 'Concluido' && this.venda?.possuiNotaNaoEletronica
	}

	async imprimirDanfe(){
		if (!this.carrinho || !this.venda) {
			this.erro = "Carrinho sem venda."
			return
		}
		if (!this.carrinho.vendedor) {
			this.erro = "Carrinho sem vendedor, informar o suporte."
			return
		}

		this.imprimindoDanfe = true
		
		try {
			
			const notaFiltrada = this.venda.notas.find(nota => nota.cstat === '100') || null
			if (!notaFiltrada) {
				this.erro = "Carrinho sem nota válida, validar com o suporte."
				return
			}

			await imprimirNotaFiscalPublic(this.venda.id, this.carrinho.vendedor.id)

		} catch(error: any){
			this.erro = "Erro ao imprimir DANFE, entre em contato com o suporte."
		} finally {
			this.imprimindoDanfe = false
		}
	}

	async imprimirDocumentoSemValorFiscal(){
		if (!this.carrinho || !this.venda) {
			this.erro = "Carrinho sem venda."
			return
		}
		
		try {
			this.imprimindoDanfe = true

			await imprimirCupomSemValorFiscalPublico(this.venda, this.carrinho.loja.id)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.imprimindoDanfe = false
		}
	}
}
